import styled from 'styled-components'

export const Container = styled.div`
  min-height: 100%;
  text-align: center;
`
export const Label = styled.label``

export const InputGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Input = styled.input`
  border-radius: 10px;
  height: 40px;
  border: 0;
  padding: 10px;
  outline: 0;
  background: #e5e7e9;
  font-size: 15px;
`

export const ResultView = styled.div`
  flex: 1;
  min-height: 100%;
  height: 100%;
  padding: 25px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
